import React from 'react';

const ClockIcon = (iconProps) => (
  <svg
    height="14"
    viewBox="0 0 9 14"
    width="9"
    xmlns="http://www.w3.org/2000/svg"
    {...{ height: 14, width: 9, ...iconProps }}
  >
    <mask id="pin-mask" fill="#fff">
      <path d="m0 0h9v14h-9z" fill="#fff" fillRule="evenodd" />
    </mask>
    <path
      d="m4.50000424 6.6129059c-1.2137327 0-2.19766084-.93848266-2.19766084-2.09617538 0-1.15767305.98392814-2.09615571 2.19766084-2.09615571s2.19766084.93848266 2.19766084 2.09615571c0 1.15769272-.98392814 2.09617538-2.19766084 2.09617538m4.49999576-2.32075506c0-2.37047808-2.01470803-4.29215084-4.49997514-4.29215084-2.48734987 0-4.49368562 1.90857326-4.50001041 4.28101823-.00198562.75536505.20080495 1.4652949.5580496 2.08250548l-.00861974-.00015735 3.52874977 7.37794804c.16495035.3449141.67864935.3449141.84362032 0l3.52874977-7.37794804-.00861973.00015735c.35549182-.61418156.55805556-1.32017763.55805556-2.07137287"
      fill="#6b6b6b"
      fillRule="evenodd"
      mask="url(#pin-mask)"
    />
  </svg>
);

export default ClockIcon;
